  slickInn = {
    selector: "div.real-users",
    prev_btn: "div.testimonialsButtons .slide-prev",
    next_btn: "div.testimonialsButtons .slide-next"
  };

 // Init
  slickInn.basicInit = function()
  {    
    $(slickInn.selector).slick({        
        swipe: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        arrows: false,
        infinite: true,
        responsive: [
        {
          breakpoint: 768,
          settings: {
           adaptiveHeight: true
          }
        }
      ]
    });
    $(slickInn.prev_btn).click(function(e) {
        $(slickInn.selector).slick('slickPrev');
    });
    $(slickInn.next_btn).click(function(e) {
        $(slickInn.selector).slick('slickNext');       
    });
}

slickInn.toogleZoom = function(){
  $(".inn-desktop .w-accordion-slider > div").on("click", function(){
    $(".inn-desktop .w-accordion-slider div").removeClass("active");
    $(this).addClass("active");
  });
  $(".inn-mobile .w-accordion-slider").slick({     
      dots: true,   
      swipe: false,
      slidesToShow: 1.1,
      slidesToScroll: 1,
      speed: 300,
      arrows: false,
      infinite: false,
      focusOnSelect: true
  });

}

slickInn.observeVideo = function(){
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        const v = e.target;
        const wasIn = v.__inView === true;
        const isIn = e.isIntersecting;

        if ($(v).hasClass("playOnce")) {
          if (isIn && !wasIn) {
            // uncomment next line to always restart from 0 on re-entry
            // v.currentTime = 0;
            v.play().catch(() => {});
          }
          if (!isIn && wasIn) {
            v.pause();
          }
        } else {
          if (isIn) v.play().catch(() => {});
          else v.pause();
        }
        v.__inView = isIn; // track last state on the element
      });
    },
    { threshold: 0.5 }
  );

  // Observe only videos inside .videoWrapper1
  $(".videoWrapper1 video").each(function () {
    io.observe(this);
  });
}